<template>

	<!-- Page header -->
	<div class="page-header page-header-light shadow">

		<!-- breadcrumb -->
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
					<router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer" v-on:click="getContatti()">Contatti</a> 
					<span class="hidden-xs ms-1">\</span>
					<span class="text-muted ms-1"><Translate :path="'dizionario.base.ELENCO'"></Translate>Contatti</span>
				</h4>
				<a href="#page_header" class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto" data-bs-toggle="collapse">
					<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
				</a>
			</div>	 
			<div class="collapse d-lg-block my-lg-auto ms-lg-auto text-center" id="page_header">
				<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">
						
					<a href="#" class="d-inline-flex align-items-center text-body lh-1 py-sm-2 position-10" style="text-align: left;" v-on:click="nuovoContatto()">
						<i class="ph-plus fw-bold me-2 btn btn-outline-success w-32px h-32px rounded-pill"></i>
						<div class="me-auto me-lg-1 ms-1">
							<div class="fs-sm text-muted mb-0">
								<Translate :path="'dizionario.base.BTN_NUOVO'"></Translate> Contatto
							</div>
							<div class="text-success fw-semibold"><Translate :path="'dizionario.base.BTN_ADD'"></Translate></div>
						</div>
					</a>

					<div class="vr flex-shrink-0 my-2 mx-3"></div>

					<div class="d-inline-flex float-end mt-sm-0">
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill" v-on:click="$root.confTravelTipologiche(25)" title="Opzioni Utenti" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-lightning"></i>
						</a>
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.confTravelLingue(25)" title="Definizioni Lingua" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-flag"></i>
						</a>
						<a href="#" class="btn btn-outline-pink btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.help(25)" title="Help OnLIne" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="icon-question7 pink"></i>
						</a>
					</div>
				</div>
			</div>
		</div>
		<!-- /breadcrumb -->

		<!-- Profile navigation -->
		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
					<li class="nav-item me-1" role="presentation">
						<a href="#contatti-1" class="navbar-nav-link navbar-nav-link-icon navbar-sm active rounded" data-bs-toggle="tab" aria-selected="true" role="tab" tabindex="-1">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-list"></i>
								<span class="hidden-lg ms-1">Contatti</span>
								<span class="hidden-xs ms-1"><Translate :path="'dizionario.base.ELENCO'" class="me-1"></Translate>Contatti</span>
							</div>
						</a>
					</li>
					<li class="nav-item me-1" role="presentation">
						<a href="#contatti-2" class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded" data-bs-toggle="tab" aria-selected="false" role="tab" id="tab-ana" v-on:click="getListe()">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-info"></i>
								<span class="hidden-lg ms-1">Liste.</span>
								<span class="hidden-xs ms-1"><Translate :path="'dizionario.base.ELENCO'" class="me-1"></Translate>Liste</span>
							</div>
						</a>
					</li>
					<li class="nav-item d-lg-none ms-auto">
						<a href="#profile_nav" class="navbar-nav-link navbar-nav-link-icon rounded-pill rounded-pill-small collapsed" data-bs-toggle="collapse" aria-expanded="false">
							<i class="ph-caret-down collapsible-indicator"></i>
						</a>
					</li>
				</ul>

				<div class="navbar-collapse collapse" id="profile_nav">
					<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0 select-small">
						<li class="nav-item dropdown ms-lg-1">
							<div class="btn-group">
								<a href="#" class="btn btn-flat-indigo border-transparent btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
									<i class="ph-gear me-1"></i>
									<span style="font-size:0.8rem;">Azioni Multiple</span>
								</a>
								<div class="dropdown-menu dropdown-menu-end" style="">
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item"><i class="far fa-ballot-check fa-fw me-2"></i><span class="text-muted me-1">|</span>Stato</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item"><i class="far fa-check-square fa-fw me-2"></i>Attiva selezionati</a>
											<a href="#" class="dropdown-item"><i class="far fa-square fa-fw me-2"></i>Disattiva selezionati</a>
										</div>
									</div>
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item"><i class="far fa-file-export fa-fw me-2"></i><span class="text-muted me-1">|</span>Comunicazioni</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i>Invia Email</a>
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i>Invia SMS</a>
										</div>
									</div>
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item"><i class="far fa-file-export fa-fw me-2"></i><span class="text-muted me-1">|</span>Esporta dati</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i>Pagina corrente</a>
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i>Utenti selezionati</a>
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i>Tutti gli Utenti</a>
										</div>
									</div>
									<div class="dropdown-divider"></div>
									<a href="#" class="dropdown-item"><i class="far fa-trash fa-fw me-2 text-danger"></i><span class="text-muted me-1">|</span>Elimina selezionati</a>
								</div>
							</div>
						</li>
						<li class="nav-item">

						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- /profile navigation -->	

	</div>
	<!-- /page header -->

	<!-- Content area -->
    <div class="content content-1 table-cms-wrapper">
		<div class="tab-content flex-1 order-2 order-lg-1">

			<div class="tab-pane fade active show" id="contatti-1">
				<div class="card shadow mb-xs-3 mb-lg-0">
					<div class="card-header d-lg-none p-1">
						<div class="d-grid gap-2">
							<a href="#collapse-all" class="btn btn-flat-info btn-sm collapsed" data-bs-toggle="collapse" role="button" aria-expanded="false">
								MOSTRA FILTRI
							</a>
						</div>
					</div>
					<div class="collapse show" id="collapse-all" style="">				
						<div class="card-body pb-0">
							<div class="alert alert-2 alert-secondary border-0">
								<form autocomplete="off" action="#" id="contatto-a">
									<div class="row">
										<div class="col-6 col-md-1 col-lg-1 mbx-1">
											<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Id Utente" v-model="search.ID_PERSONA_FISICA.VALUE" :tabindex="7" />
										</div>
										<div class="col-6 col-md-1 col-lg-1 mbx-1">
											<select class="form-select form-select-sm" v-model="search.SESSO.VALUE" data-placeholder="Sesso" :tabindex="13">
												<option value="">Sesso </option>   
												<option value="1"> &nbsp; Uomo</option>
												<option value="2"> &nbsp; Donna</option>
											</select>
										</div>
										<div class="col-12 col-md-1 col-lg-1 mbx-1">
											<select class="form-select form-select-sm" v-model="search.FK_ID_LISTA.VALUE">
												<option value="">TUTTI</option>
												<option v-for="lista in arrayListe" v-bind:value="lista.ID_LISTA" v-bind:key="lista.ID_LISTA">{{lista.DESCRIZIONE}}</option>
											</select>
										</div>	
										<div class="col-12 col-md-5 col-lg-5">
											<div class="row">
												<div class="col-6 mbx-1 col-md-3 mbx-1">
													<select class="form-select form-select-sm" v-model="search.FK_ID_RUOLO.VALUE">
														<option value="">Ruolo</option>
														<option v-for="ruolo in $root.arrayRuoliUtente" v-bind:value="ruolo.ID_OPZIONE_TIPOLOGICA" v-show="checkShowRuolo(ruolo)" v-bind:key="ruolo.DESCRIZIONE"> &nbsp; {{ ruolo.DESCRIZIONE }}</option>
													</select>
												</div> 
												<div class="col-6 mbx-1 col-md-3 mbx-1">
													<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Cognome" :tabindex="9" v-model="search.COGNOME.VALUE" />
												</div>
												<div class="col-6 col-md-3 col-lg-3 mbx-1">
													<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Nome" :tabindex="9" v-model="search.NOME.VALUE" />
												</div>	
												<div class="col-6 mbx-1 col-md-3 mbx-1">
													<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Email" :tabindex="10" v-model="search.EMAIL.VALUE" />
												</div> 										
											</div>
										</div>	
										<div class="col-12 col-md-4 col-lg-4">
											<div class="row">
												<div class="col-6 col-md-4 col-lg-4 mbx-1">
													<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Codice Fiscale" :tabindex="11" v-model="search.CODICE_FISCALE.VALUE" />
												</div> 
												<div class="col-6 col-md-4 col-lg-4 mbx-1">
													<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Telefono" :tabindex="9" v-model="search.TELEFONO.VALUE" />
												</div>
												<div class="col-6 col-md-4 col-lg-4">
													<select class="form-select form-select-sm" data-placeholder="Stato" v-model="search.STATO.VALUE" :tabindex="13">
														<option value="">Tutti </option>   
														<option value="1"> &nbsp; Attivati</option>
														<option value="0"> &nbsp; Disattivati</option>
														<option v-show="$root.utente.FK_ID_LIVELLO == 1" value="2"> &nbsp; Eliminati</option>
													</select>
												</div>
										   </div>
									  </div>
									</div>	
								</form>
							</div>
						</div> 
					</div>
				
			        <div class="card-body box-card mt-0 mb-0" id="box-card">
						<div class="div_table_resp tableFixHead" id="tableFixHead">
		               		<table class="table table-bordered table-hover table-striped table-togglable text-nowrap"> 
			                    <thead class="sticky-top">
									<tr class="bg-secondary text-white">
										<th class="hidden-xs table-head-sm" style="width:2%;"> <input id="chkAllUsers" v-on:click="filters.selectAll('chkAllUsers',paginatedList.arr)" type="checkbox" class=""> </th>
										<th class="table-head-sm" style="width:6%;"> #<ISort class="float-end" v-model="ordinamento"  :campo="'DESCRIZIONE'"></ISort><br /><span class="float-end">Ord. </span></th>
										<th class="table-head-sm" style="width:35%;">Nominativo<ISort class="float-end" v-model="ordinamento"  :campo="'DESCRIZIONE'"></ISort><br />Contatti</th>
										<th class="hidden-xs table-head-sm" style="width:12%;">Cellulare<br>Tel. Ufficio / Tel. Casa</th>
										<th class="hidden-xs table-head-sm" style="width:25%;">Data di Nascita /<br />Residenza</th>
										<th class="hidden-xs table-head-sm" style="width:15%;">Login / Password</th>
										<th class="table-head-sm text-center" style="width:5%;">Azioni</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="contatto in paginatedList.arr" v-bind:key="contatto.ID_PERSONA_FISICA">
										<td class="hidden-xs td-class text-center">
											<span class="footable-toggle"></span>
											<input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="contatto.SELEZIONATO" class=""> 
										</td>
										<td class="td-class fs-sm">
											<span>{{contatto.ID_PERSONA_FISICA}}</span><br />
											<small class="badge bg-light badge-xs text-primary cursor-pointer float-end"> &nbsp; </small>
										</td>
										<td class="td-class fs-sm">
											<div>
												<span class="text-primary text-uppercase fw-bold cursor-pointer" v-on:click="openOffCanvas();openSchedaVisualizzazionePersonaFisica(contatto)">{{contatto.COGNOME}} {{contatto.NOME}}</span>
												<i v-show="contatto.NOTE != ''" class="ph-info fs-base lh-base align-top text-pink float-end cursor-pointer me-1" style="margin-top: -1.5px;" title="Note personali" data-bs-toggle="tooltip" data-bs-placement="top" v-on:click="showNote(contatto)"></i>
											</div>
											<div>
												<span class="badge bg-light badge-xs text-dark rounded-0 me-1" style="border: 1px #dddddd solid;" v-show="contatto.LISTE != ''"><i class="fal fa-tag fa-fw"></i> {{contatto.LISTE.DESCRIZIONE}}</span>
												<span class="badge bg-light badge-xs text-dark rounded-0 me-1" style="border: 1px #dddddd solid;" data-bs-toggle="tooltip" data-bs-placement="top" :title="contatto.EMAIL" v-bind:href="`mailto:${contatto.EMAIL}`"><i class="fal fa-envelope fa-fw"></i> Email</span>
												<span class="badge bg-light badge-xs text-dark rounded-0 me-1" style="border: 1px #dddddd solid;" data-bs-toggle="tooltip" data-bs-placement="top" :title="contatto.TELEFONO" v-bind:href="`tel:${contatto.TELEFONO}`"><i class="fal fa-phone fa-fw"></i> Cell.</span>
											</div>																					
										</td>  
										<td class="hidden-xs td-class fs-sm">
											<span><i class="far fa-phone fa-fw me-1"></i> {{contatto.TELEFONO}}</span><br>
											<span><i class="far fa-phone-rotary fa-fw me-1"></i> {{contatto.TELEFONO}}</span>
										</td>
										<td class="hidden-xs td-class fs-sm">
											<span class="text-dark" data-bs-toggle="tooltip" data-bs-placement="top" title="Data di Nascita"><i class="fal fa-calendar-alt fa-fw me-1"></i>{{filters.formatDate(contatto.DATA_NASCITA)}}</span><br />
											<span class="text-muted"><i class="fal fa-map-marker-alt fa-fw me-1"></i>{{contatto.INDIRIZZO}} {{contatto.CIVICO}}, {{contatto.CAP}} ({{contatto.PROV}})</span>
										</td>
										<td class="hidden-xs td-class fs-sm">
											<i class="ph-check-circle fs-base lh-base align-top text-success me-1"></i> Login: <br>
											<i class="ph-clock fs-base lh-base align-top text-danger me-1"></i> Password:  
										</td>
										<td class="td-class text-center">
											<div class="dropdown">
												<a href="#" class="text-body" data-bs-toggle="dropdown" aria-expanded="false">
													<i class="ph-list"></i>
												</a>
												<div class="dropdown-menu dropdown-menu-end">
													<a href="#" class="dropdown-item" v-on:click="modificaContatto(contatto)"><i class="fad fa-pencil fa-fw me-2"></i><span class="text-muted me-1">|</span>Modifica Contatto</a>
													<div class="dropdown-divider"></div>
													<a href="#" class="dropdown-item" v-on:click="deleteContatto(contatto)"><i class="fad fa-trash fa-fw text-danger me-2"></i><span class="text-muted me-1">|</span>Elimina Contatto</a>
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
		
		                <div class="row page-bottom">
							<div class="col-12 col-md-5 d-none d-sm-block" :tabindex="27">
                                <div style="position: relative; top: 10px;">
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2"><span>CONTATTI</span>: {{ paginatedList.count }}</span> 
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 ms-2"></span>
                                </div>
                            </div>
							<div class="col-9 col-md-6" :tabindex="27">
		                        <div class="float-end pag-mobile">
			                        <Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count" :numpagine="search.PAGINATION.LENGTH"></Pagine>
			                    </div>
			                </div>
							<div class="col-3 col-md-1" :tabindex="28">
								<select class="form-select form-select-sm wmin-100 mt-2 float-end" data-placeholder="Limite" :tabindex="20" v-model="search.PAGINATION.PAGE_SIZE" style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
		                            <option value="5">5</option>
		                            <option value="10">10</option>
		                            <option value="25">25</option>
		                            <option value="50">50</option>
		                            <option value="75">75</option>
		                            <option value="100">100</option>
		                            <option value="250">250</option>
		                            <option value="500">500</option>
		                        </select>
			            	</div>
			        	</div>
					</div>
				</div>
			</div>

			<div class="tab-pane fade" id="contatti-2">
				<div class="card shadow mb-xs-3 mb-lg-0">
					<div class="card-header d-lg-none p-1">
						<div class="d-grid gap-2">
							<a href="#collapse-all" class="btn btn-flat-info btn-sm collapsed" data-bs-toggle="collapse" role="button" aria-expanded="false">
								MOSTRA FILTRI
							</a>
						</div>
					</div>
					<div class="collapse show" id="collapse-all" style="">				
						<div class="card-body pb-0">
							<div class="alert alert-2 alert-secondary border-0">
								<form autocomplete="off" action="#" id="conf-a">
                                    <div class="row">
                                        <div class="col-12 col-md-2 mbx-1">
                                            <input autocomplete="off" class="form-control form-control-sm" placeholder="Descrizione" type="text" v-model="searchListe.DESCRIZIONE.VALUE">
                                        </div>           
                                        <div class="col-12 col-md-6 mbx-1">
                                        </div>          
                                        <div class="col-12 col-md-4">
                                            <div class="row">
                                                <div class="d-none d-sm-block col-md-6 form-group-filter">
                                                </div>
                                                <div class="col-6 col-md-3 mbx-1">
                                                </div>
                                                <div class="col-6 col-md-3 form-group-filter">
                                                    <select class="form-control form-control-sm" data-placeholder="Stato" :tabindex="13" v-model="searchListe.STATO.VALUE">
                                                        <option value="">Tutti </option>   
                                                        <option value="1"> &nbsp; Attivati</option>
                                                        <option value="0"> &nbsp; Disattivati</option>
                                                    </select>
                                                </div> 
                                            </div>
                                        </div>  
                                    </div>
                                </form>
                            </div> 
					   	</div>
					</div>

			        <div class="card-body box-card mt-0 mb-0" id="box-card">
						<div class="div_table_resp tableFixHead" id="tableFixHead">
		               		<table class="table table-bordered table-hover table-striped table-togglable text-nowrap"> 
			                    <thead class="sticky-top">
									<tr class="bg-secondary text-white">
                                        <th class="table-head-sm" style="width: 6%;">#</th>
                                        <th class="table-head-sm" style="width: 40%;">Descrizione</th> 		                                           
										<th class="table-head-sm" style="width: 38.6%;">Contatti</th>
									    <th class="table-head-sm text-center" style="width: 5.4%;">Stato</th> 
		                                <th class="table-head-sm text-center" style="width: 10%;">
											<div class="btn btn-light btn-sm" v-on:click="nuovaLista()"><i class="fa fa-plus fa-fw"></i></div>
										</th> 
                                    </tr>
                                </thead> 
                                <tbody>
                                    <tr v-for="lista in paginatedListListe.arr" v-bind:key="lista.ID_LISTA">
                                        <td class="td-class fs-12" style="height:2.72rem;">                                                
                                            {{lista.ID_LISTA}}
                                        </td>
										<td class="td-class fs-12" > 
											<input class="form-control form-control-sm" type="text" v-on:keyup="lista.FLG_MODIFICA = 1" v-model="lista.DESCRIZIONE">
										</td>
										<td class="td-class fs-12" >
											{{ lista.TOT }}
										</td>
										<td class="td-class fs-12" >
											<ISwitch @toggle="lista.FLG_MODIFICA = 1" :size="'sm'" v-model="lista.STATO" style="z-index: 0;"></ISwitch>
										</td>
										<td class="td-class fs-12" >
											<button class="badge bg-danger border-0 me-2" v-show="lista.FLG_MODIFICA" v-on:click="salvaLista(lista)">salva</button>
										</td>
                                    </tr>
                                </tbody>
                            </table>
						</div>
                
                		<div class="row page-bottom">
                            <div class="col-12 col-md-5 d-none d-sm-block" :tabindex="27">
                                <div style="position: relative; top: 10px;">

                                </div>
                            </div>
							<div class="col-9 col-md-6" :tabindex="27">
		                        <div class="float-end pag-mobile">
                                    <Pagine v-model="searchListe.PAGINATION.PAGE_NUMBER" :numrighe="paginatedListListe.count" :numpagine="searchListe.PAGINATION.LENGTH"></Pagine>
			                    </div>
			                </div>
							<div class="col-3 col-md-1" :tabindex="28">
                                <select class="form-select form-select-sm wmin-100 mt-2 float-end" data-placeholder="Limite" :tabindex="20" v-model="searchListe.PAGINATION.PAGE_SIZE" style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="75">75</option>
                                    <option value="100">100</option>
                                    <option value="250">250</option>
                                    <option value="500">500</option>
                                </select>
                            </div>
                        </div>
                    </div>				
				</div>
			</div>
			
		</div>
	</div>	


	<!-- START MODALI -->
    <div class="offcanvas offcanvas-end offcanvas-size-xlg" id="panel_right" data-bs-backdrop="false" role="dialog" tabindex="-1">
		<div class="offcanvas-header bg-info text-white border-0" style="height: 3.95rem;">
			<h5 class="modal-title modal-title-width">
				<i class="ph-list icon-modal-size me-2"></i>Scheda Informativa
			</h5>  
			<div class="btn-group float-end" :tabindex="2" >
				<a href="#" class="badge bg-light text-dark p-2 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">Azioni Marketing</a>
				<div class="dropdown-menu dropdown-position dropdown-menu-end" data-popper-placement="bottom-start" style="position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate3d(0px, 42px, 0px);">
					<a href="#" class="dropdown-item"><i class="fal fa-print fa-fw me-2"></i><span class="text-muted me-1">|</span>Stampa scheda </a>
					<a href="#" class="dropdown-item"><i class="fal fa-envelope fa-fw me-2"></i><span class="text-muted me-1">|</span>Invia email </a>
					<a href="#" class="dropdown-item"><i class="fal fa-paper-plane fa-fw me-2"></i><span class="text-muted me-1">|</span>Invia sms </a>
				</div>
			</div> 	
			<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="offcanvas">
				<i class="ph-x icon-x-size"></i>
			</button>
		</div>
		<div class="offcanvas-body p-2">

			<div class="row" style="height: 8.75rem;">
				<div class="col-3 col-md-3 mb-2">
					<div src="../assets/images/placeholders/placeholder.jpg" class="rounded" style="width: 150px !important;" alt=""></div>
				</div>
				<div class="col-9 col-md-9 mb-2" style="height: 6.7rem;">
					<h4 class="text-primary mb-1"> 
						{{contattoSelezionato.COGNOME}} {{ contattoSelezionato.NOME }}
						<span v-on:click="modificaContatto(contattoSelezionato)" class="badge bg-danger bg-opacity-20 text-danger cursor-pointer float-end p-1">
							<span class="hidden-xs fw-semibold text-danger">Modifica Contatto</span>
							<i class="hidden-sm fa fa-edit fa-fw ms-2"></i>
						</span>
					</h4>
					<p class="text-dark mb-1"><i class="fal fa-tag fa-fw me-1" data-bs-toggle="tooltip" data-bs-delay="300" data-bs-placement="top" title="Ruolo ricoperto"></i><span class="text-light me-1">|</span>RUOLI</p>
					<p class="text-dark mb-1"><i class="fal fa-calendar fa-fw me-1" data-bs-toggle="tooltip" data-bs-delay="300" data-bs-placement="top" title="Data creazione"></i><span class="text-light me-1">|</span>{{ filters.formatDateTime(contattoSelezionato.DATA_CREAZIONE) }}</p>
		            <p class="text-dark mb-1"><i class="fal fa-info fa-fw me-1" data-bs-toggle="tooltip" data-bs-delay="300" data-bs-placement="top" title="Note inportanti"></i><span class="text-light me-1">|</span>
		                <span class="textarea rounded note-modal-show" v-html="contattoSelezionato.NOTE"></span>
		            </p>
					<p class="mb-0">&nbsp;</p>
				</div> 
			</div>

    		<p>&nbsp;</p>

			<div class="row bg-light" style="border-top: 1px solid #ccc;">
				<div class="col-12 ps-0 pe-0">
					<div class="navbar navbar-expand-lg bg-light border-bottom py-1">
						<div class="container-fluid">
							<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
								<li class="nav-item me-1" role="presentation">
									<a href="#scheda-1" id="tab-ana" class="navbar-nav-link navbar-nav-link-icon active rounded" data-bs-toggle="tab" aria-selected="true" role="tab">
										<div class="d-flex align-items-center mx-lg-1">
											<i class="ph-info"></i>
											<span class="d-none d-lg-inline-block ms-1">Anagrafica</span>
										</div>
									</a>
								</li>
								<li class="nav-item me-1" role="presentation"> <!--v-show="lista.SELEZIONATO == 1" -->
									<a href="#scheda-2" class="navbar-nav-link navbar-nav-link-icon rounded" data-bs-toggle="tab" aria-selected="false" tabindex="-1" role="tab">
										<div class="d-flex align-items-center mx-lg-1">
											<i class="ph-list-checks"></i>
											<span class="d-none d-lg-inline-block ms-1">Liste</span>
										</div>
									</a>
								</li>
								<li class="nav-item me-1" role="presentation">
									<a href="#scheda-5" class="navbar-nav-link navbar-nav-link-icon rounded" data-bs-toggle="tab" aria-selected="false" tabindex="-1" role="tab">
										<div class="d-flex align-items-center mx-lg-1">
											<i class="ph-clock-clockwise"></i>
											<span class="d-none d-lg-inline-block ms-1">Storico</span>
										</div>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>

			<div class="content content-2">
				<div class="tab-content flex-1 order-2 order-lg-1">

					<div class="tab-pane fade active show" id="scheda-1">
						<form action="#">
							<fieldset>

								<PersonaFisica :modalita=2 v-model="contattoSelezionato"></PersonaFisica>


							</fieldset>
						</form>
					</div>

					<div class="tab-pane fade" id="scheda-2"><!--v-show="lista.SELEZIONATO == 1" -->
						<form action="#">
							<fieldset>
								<legend class="fs-base fw-bold border-bottom pb-2 mb-2"><i class="ph-list-checks me-2"></i>Elenco Liste</legend>	
								<div class="box-29">
									<div class="row">
										<div class="col-md-3" style="margin-bottom: 10px;" v-for="lista in contattoSelezionato.liste" v-bind:key="lista.ID_LISTA">
											<div class="card lift-panel shadow" style="height: 45px;" v-bind:class="getClassLista(lista)">
												<div class="card-body d-flex h-100" style="padding: 0.25rem 0.5rem; font-weight: bold;">
													<div class="justify-content-center align-self-center" style="font-size: 14px;">
														<i class="fal fa-tag fa-fw"></i> {{ lista.DESCRIZIONE }}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>	
							</fieldset>
						</form>	
					</div>

					<div class="tab-pane fade" id="scheda-5">
						<form action="#">
							<fieldset>
								<legend class="fs-base fw-bold border-bottom pb-2 mb-3"><i class="ph-clock-clockwise me-2"></i>Storico del Contatto
									
								</legend>	
							
								<div class="tableFixHead tableFixHeadRoles">
									<div class="list-feed">
										<div class="list-feed-item">
											<div class="text-muted">Jan 12, 12:47</div>
											<a href="#">David Linner</a> requested refund for a double bank card charge
										</div>

										<div class="list-feed-item">
											<div class="text-muted">Jan 11, 10:25</div>
											User <a href="#">Christopher Wallace</a> from Google is awaiting for staff reply
										</div>

										<div class="list-feed-item">
											<div class="text-muted">Jan 10, 09:37</div>
											Ticket <strong>#43683</strong> has been resolved by <a href="#">Victoria Wilson</a>
										</div>

										<div class="list-feed-item">
											<div class="text-muted">Jan 9, 08:28</div>
											<a href="#">Eugene Kopyov</a> merged <strong>Master</strong>, <strong>Demo</strong> and <strong>Dev</strong> branches
										</div>

										<div class="list-feed-item">
											<div class="text-muted">Jan 8, 07:58</div>
											All sellers have received payouts for December, 2016!
										</div>

										<div class="list-feed-item">
											<div class="text-muted">Jan 7, 06:32</div>
											<a href="#">Chris Arney</a> created a new ticket <strong>#43136</strong> and assigned to <a href="#">John Nod</a>
										</div>
									</div>
								</div> 
								
							</fieldset>
						</form>  
					</div>

				</div>
			</div>

		</div>
        <div class="border-top p-1 bg-light">                                
			<button type="button" class="btn btn-link float-end" data-bs-dismiss="offcanvas">
				<i class="fal fa-sign-out-alt fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
			</button> 
        </div>  
	</div>	 

	<div class="modal fade" id="modalNote" role="dialog" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header bg-info text-white border-0">
					<h5 class="modal-title">
						<i class="ph-list icon-modal-size me-2"></i><span class="me-2">Contatto:</span>{{ contattoSelezionato.NOME }} {{ contattoSelezionato.COGNOME }}  
					</h5>
					<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="modal">
						<i class="ph-x icon-x-size"></i>
					</button>
				</div>
				<div class="modal-body" style="height: 15rem;">

					<h6 class="fw-semibold mb-1">
						<i class="ph-info me-2"></i>Note Importanti:
					</h6>
					<p>hgjhgghgjg</p>
					<hr />

					<div class="textarea rounded" v-html="contattoSelezionato.NOTE"></div>

				</div>
				<div class="modal-footer bg-light p-1">                                
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">
						<i class="fal fa-sign-out-alt fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
					</button>
				</div>
			</div>
		</div>
	</div> 

    <div class="modal fade" id="popUpPersonaFisica" role="dialog" tabindex="-1">
		 <div class="modal-dialog modal-xl">
            <div class="modal-content">

                <div class="modal-header bg-secondary text-white border-0">
					<h5 class="modal-title">
						<i class="ph-list icon-modal-size me-2"></i><span class="me-2">Scheda:</span>{{ contattoSelezionato.NOME }} {{ contattoSelezionato.COGNOME }} 
					</h5>
					<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="modal"><i class="ph-x icon-x-size"></i></button>
                </div> 
                <div class="modal-body p-2" style="height: 33rem;"> 
					
                    <div class="card card-noshadow mb-0">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                    <div class="sidebar-content">
                                        <div class="card sidebar-section-body text-center p-2">
                                            <div class="card-img-actions d-inline-block">
                                                <img src="../../assets/images/placeholders/placeholder.jpg" class="img-fluid rounded-circle" width="150" height="150" alt="">
                                                <div class="card-img-actions-overlay card-img rounded-circle">
                                                    <span class="btn btn-outline-white btn-icon rounded-pill">
                                                        <i class="ph-pencil"></i>
													</span>
                                                </div>
                                            </div>
                                        </div>

                                        <ul class="nav nav-sidebar" role="tablist">
											<li class="nav-item" role="presentation">
                                                <a href="#tab-1" class="nav-link active" data-bs-toggle="tab" aria-selected="true" role="tab">
                                                    <i class="ph-user me-2"></i>Anagrafica
                                                </a>
                                            </li>
											<li class="nav-item" role="presentation">
                                                <a href="#tab-2" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab">
                                                    <i class="ph-list me-2"></i>Liste
                                                </a>
                                            </li>
										</ul>
									</div>

								</div>
                                <div class="col-12 col-md-10 col-lg-10">
                                    <div class="tab-content flex-fill">
                                        
                                        <div class="tab-pane fade active show" id="tab-1" role="tabpanel">
                                            <h5 class="label-bar"><i class="fad fa-user fa-fw me-1"></i> Dati Personali</h5>
                                            <div class="box-utenti"> 
			
												<PersonaFisica v-model="contattoSelezionato"></PersonaFisica>

											</div>
										</div>	

										<div class="tab-pane fade" id="tab-2" role="tabpanel">
											<h5 class="label-bar"><i class="fad fa-tags fa-fw me-1"></i> Elenco Liste</h5>
											<div class="box-utenti"> 

												<div class="row">
													<div class="col-md-3" style="margin-bottom: 10px;" v-for="lista in contattoSelezionato.liste" v-bind:key="lista.ID_LISTA">
														<div class="card lift-panel cursor-pointer shadow" style="height: 45px;" v-bind:class="getClassLista(lista)" v-on:click="gestioneSelezioneLista(lista)">
															<div class="card-body d-flex h-100" style="padding: 0.25rem 0.5rem; font-weight: bold;">
																<div class="justify-content-center align-self-center" style="font-size: 14px;">
																	<i class="fal fa-tag fa-fw"></i> {{ lista.DESCRIZIONE }}
																</div>
															</div>
														</div>
													</div>
												</div>

											</div>
										</div>

									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
				<div class="modal-footer bg-light p-1">                                
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">
						<i class="fal fa-sign-out-alt fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
					</button>
					<button class="btn btn-secondary float-end" v-on:click="salvaPersonaFisica()"><i class="fal fa-save fa-fw me-1"></i> Salva Modifiche </button>                                   
				</div>
			</div>
		</div>
	</div>

</template>



<script>

import Pagine from '@/components/utils/Pagine.vue'
import ISwitch from '@/components/utils/ISwitch.vue'
import ISort from '@/components/utils/ISort.vue'
import PersonaFisica from '@/components/common/PersonaFisica.vue' 


export default {
    name:"Contatti",

    components:{
        Pagine,
		ISwitch,
		ISort,
		PersonaFisica
		       
    },		

    data: function () {
        return {   
            apiStartup:'core/contatti/startup',
            filters:global.filters,
            GLOBAL_IMAGES_PATH:'',
			anno:new Date().getFullYear(),
            livelloMaxFiltroSocieta: 2,
            arrayContatti: new Array(),
            contattoSelezionato : {comuneNascita:{},comuneResidenza:{},nazionalita:{}}, 
            contattoCorrente:{},
			modulo:0,
		    ordinamento:'',
            search:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:25},
				ANNO_ORDINE:{TYPE:'COMBO',VALUE: new Date().getFullYear()},
                ID_PERSONA_FISICA:{TYPE:'TEXT',VALUE:''},
				DENOMINAZIONE : {TYPE:'TEXT',VALUE:''},
				FK_ID_LISTA:{TYPE:'COMBO_IN_ARRAY',VALUE:'',ARRAY:"LISTE"},
                EMAIL:{TYPE:'TEXT',VALUE:''},
                NOME:{TYPE:'TEXT',VALUE:''},
                SESSO:{TYPE:'TEXT',VALUE:''},
                COGNOME:{TYPE:'TEXT',VALUE:''},
				CODICE_FISCALE:{TYPE:'TEXT',VALUE:''},
				DATA_CREAZIONE:{TYPE:'DATE_RANGE',VALUE_FROM:'',VALUE_TO:''},
				TELEFONO:{TYPE:'TEXT',VALUE:''},
                FK_ID_RUOLO:{TYPE:'COMBO',VALUE:''},
				FK_ID_POSIZIONE:{TYPE:'COMBO',VALUE:''},
				FK_ID_TIPOLOGIA:{TYPE:'COMBO',VALUE:''},				
				FK_ID_COMUNE:{TYPE:'COMBO',VALUE:''},	
				FK_ID_REGIONE:{TYPE:'COMBO',VALUE:''},	
				FK_ID_NAZIONALITA:{TYPE:'COMBO',VALUE:''},	
                STATO:{TYPE:'COMBO',VALUE:'1'},	

            },
			arrayListe:new Array(),
			searchListe:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:25},
				DESCRIZIONE : {TYPE:'TEXT',VALUE:''},    
                STATO:{TYPE:'COMBO',VALUE:'1'},	
            },
			dataCreazioneRange:{},
		
        }
    },

    methods: { 

        getContatti : function () {
            utils.ajax("core/admin/contatti",{ANNO:this.search.ANNO_ORDINE.VALUE}, (response) => {
                this.arrayContatti = response.data;
            }); 
        }, 

		nuovoContatto : function(){
            this.contattoSelezionato = {ID_PERSONA_FISICA:0,SESSO:"",FK_ID_ENTE:this.$root.idEnteCorrente};
            this.filters.openPopUp("popUpPersonaFisica");
        }, 

		modificaContatto: function(contatto){
			utils.ajax("travel/personaFisica",{ID_PERSONA_FISICA:contatto.ID_PERSONA_FISICA}, (response) => {
                this.contattoSelezionato = response.data;
            	this.filters.openPopUp("popUpPersonaFisica");
            });  
		}, 

		salvaPersonaFisica : function(){
			const metodo = this.contattoSelezionato.ID_PERSONA_FISICA > 0 ? "travel/pf/update" : "travel/pf/insert";
			utils.ajax(metodo,this.contattoSelezionato, (response) => {
				if (response.esito == 0){
					utils.alert.success(response.messaggio);
					this.filters.closePopUp("popUpPersonaFisica");
				}
				else{
					utils.alert.warning(response.messaggio);
				}
            	
            });
		},

        updateStatoPersonaFisica : function(contatto){
            setTimeout(() => {
                utils.ajax('core/utente/stato/update',contatto, (response) => {
                    if (response.esito == 0){
                        utils.alert.success(response.messaggio);
                    }  
                }); 
            },250);
        },

		deletePersonaFisica : function(contatto){
			utils.ajax('core/utente/stato/update',contatto, (response) => {
				if (response.esito == 0){
					utils.alert.success(response.messaggio);
				}  
			}); 
		},
        
        showNote : function(contatto){
			utils.ajax("travel/personaFisica",{ID_PERSONA_FISICA:contatto.ID_PERSONA_FISICA}, (response) => {
                this.contattoSelezionato = response.data;
				this.filters.openPopUp("modalNote"); 
            });  
        },	



		checkShowRuolo : function(ruolo){			
			
		}, 

		openOffCanvas : function(){
			var myOffcanvas = document.getElementById('panel_right')
			var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas)
			bsOffcanvas.show();
		},

		openSchedaVisualizzazionePersonaFisica : function(contatto,tab = "",opzioni = null){
			utils.ajax("travel/personaFisica",{ID_PERSONA_FISICA:contatto.ID_PERSONA_FISICA}, (response) => {
                this.contattoSelezionato = response.data;
            }); 
		},
			
        getLabelOpzioneUtente : function(label){
            var opzione = utils.array.select(this.contattoSelezionato.opzioni,"LABEL",label,1)[0];
            if (opzione != undefined){
                return filters.getLabel(this.$root.arrayAllOpzioni,'ID_OPZIONE_TIPOLOGICA',opzione.VALORE,'DESCRIZIONE');
            }
        },



		//liste
		getListe: function () {
            utils.ajax("travel/liste",{}, (response) => {
                this.arrayListe = response.data;				
            }); 
        },

		nuovaLista : function(){
			this.arrayListe.push({ID_LISTA:0,STATO:1,FLG_MODIFICA:1});
		},

		salvaLista : function(lista){
			const metodo = lista.ID_LISTA > 0 ? "travel/lista/update" : "travel/lista/insert";
			utils.ajax(metodo,lista, (response) => {
				if (response.esito == 0){
					utils.alert.success(response.messaggio);
					lista.ID_LISTA = response.id_inserito;
					lista.FLG_MODIFICA = 0;
				}
				else{
					utils.alert.warning(response.messaggio);
				}
            	
            });
		},

		gestioneSelezioneLista : function(lista){
			const item = {FK_ID_LISTA:lista.ID_LISTA,FK_ID_PERSONA_FISICA:this.contattoSelezionato.ID_PERSONA_FISICA};
			var contatto = utils.array.select(this.arrayContatti,"ID_PERSONA_FISICA",this.contattoSelezionato.ID_PERSONA_FISICA)[0];
			if (lista.SELEZIONATO == 1){				
				utils.ajax("travel/listapf/delete",item, (response) => {
					lista.SELEZIONATO = 0;
					for (var i = 0 ; i < contatto.LISTE.length ; i++){
						if (contatto.LISTE[i].FK_ID_LISTA == lista.ID_LISTA){
							contatto.LISTE.splice(i,1);
						}
					}
				});
			}
			else{
				utils.ajax("travel/listapf/insert",item, (response) => {
					lista.SELEZIONATO = 1;
					var lCopy = utils.clone(lista);
					lCopy.FK_ID_LISTA = lista.ID_LISTA;
					contatto.LISTE.push(lCopy);
				});
			}
		},

		getClassLista : function(lista){
			if (lista.SELEZIONATO == 1){
				return "bg-success text-white";
			} else {
				return "bg-light text-dark";
			}
		},


    },

    computed: {
        paginatedList(){
            var arr = utils.inGrid(this.arrayContatti,this.search,this.ordinamento);
            return arr;
        },	 
		paginatedListListe(){
            var arr = utils.inGrid(this.arrayListe,this.searchListe);
            return arr;
        },	 

		getTotali(){
			var attive = 0;
            var inattive = 0; 
			var arrayContatti = utils.filter(this.arrayContatti,this.search);
			for (var i = 0; i < arrayContatti.length; i++) {
				if (arrayContatti[i].STATO == 1) {
					attive++;
				} else {
					inattive++;
				}
            }
            return {
                COUNT:this.arrayContatti.length,
				USER_OK:attive,
				USER_KO:inattive,
            }
        },

		annoCorrente : function(){
			return new Date().getFullYear();
		},

		annoPrecedente : function(){
			return new Date().getFullYear() - 1;
		}

    },
    
	watch:{
	
	},
    



    created: function () {
        global.utils.BASE_API = process.env.VUE_APP_API_URL;
        utils.ajax("core/contatti/startup",{}, (response) => {
			this.arrayListe = response.data.LISTE;			                 
			var arrayContatti = response.data.CONTATTI.data;//global.utils.getArrayFromJSON(rarrayCampi,response.data.CONTATTI.arrayValori);
			for (var i = 0 ; i < arrayContatti.length ; i++){
				arrayContatti[i].FK_ID_LISTA = 0;
				arrayContatti[i].LISTE = new Array();
				
				for (var j = response.data.LISTE_PF.length -1 ; j > -1 ; --j ){
				 	if (response.data.LISTE_PF[j].FK_ID_PERSONA_FISICA == arrayContatti[i]['ID_PERSONA_FISICA']){
						arrayContatti[i].LISTE.push(response.data.LISTE_PF[j]);
						response.data.LISTE_PF.splice(j,1);
						
					}
				}

			}
			this.arrayContatti = arrayContatti;
		});

    } 

}
</script>